import { Component, OnInit, Input } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-orientation-alert',
  templateUrl: './orientation-alert.component.html',
  styleUrls: ['./orientation-alert.component.scss']
})
export class OrientationAlertComponent implements OnInit {

  mobile = false;

  @Input('orientation') orientation;

  constructor(private deviceService: DeviceDetectorService) { }

  ngOnInit(): void {
    this.mobile = this.deviceService.isMobile();
  }

}
